import type { IPointerHandler } from '@/components/viewPort/PointerController';
import type { SyntheticEvent } from '@/components/viewPort/SyntheticEvent';
import type { ImagesService } from './Images.service';
import type { SliceType } from './interfaces';
import type { IImageScrollStrategiesFactory } from '@/engine/app/modules/images/ImageScrollStrategies.factory.ts';

export class PointerHandlerScrollImages implements IPointerHandler {
  private readonly _sliceType: SliceType;

  private readonly _imagesService: ImagesService;

  private readonly _imageScrollStrategiesFactory: IImageScrollStrategiesFactory;

  public setParent(): void {
    return;
  }

  public constructor(
    imagesService: ImagesService,
    imageScrollStrategiesFactory: IImageScrollStrategiesFactory,
    sliceType: SliceType
  ) {
    this._imagesService = imagesService;
    this._imageScrollStrategiesFactory = imageScrollStrategiesFactory;
    this._sliceType = sliceType;
  }

  public onWheel(event: SyntheticEvent<WheelEvent>): void {
    this._imageScrollStrategiesFactory
      .createImageScrollStrategy(this._sliceType)
      .handleScroll(this._getScrollDelta(event), this._sliceType);
  }

  private _getScrollDelta(event: SyntheticEvent<WheelEvent>): number {
    let delta = -event.originalEvent.deltaY;

    switch (event.originalEvent.deltaMode) {
      case 2:
        // Scroll in pages (default is 1pg)
        break;
      case 1:
        // Scroll in lines (default is 3ln)
        delta /= 3;
        break;
      default:
        // undefined, 0, assume pixels (default is 100px)
        delta /= 100;
        break;
    }

    return delta;
  }
}
